"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _FormattedVideoCredits = _interopRequireDefault(require("../../../common/FormattedVideoCredits"));

require("../styles/_team-allocations.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Allocation(_ref) {
  var _ref$team = _ref.team,
      teamId = _ref$team.teamId,
      name = _ref$team.name,
      imageUrl = _ref$team.imageUrl,
      creditBalance = _ref$team.creditBalance,
      creditRule = _ref$team.creditRule;

  var _ref2 = creditBalance || {},
      _ref2$balance = _ref2.balance,
      balance = _ref2$balance === void 0 ? 0 : _ref2$balance,
      _ref2$rolloverBalance = _ref2.rolloverBalance,
      rolloverBalance = _ref2$rolloverBalance === void 0 ? 0 : _ref2$rolloverBalance;

  var _ref3 = creditRule || {},
      _ref3$creditQuantity = _ref3.creditQuantity,
      creditQuantity = _ref3$creditQuantity === void 0 ? 0 : _ref3$creditQuantity;

  return /*#__PURE__*/_react.default.createElement(_uiKit.List.CardItem, {
    coverImageProps: {
      imageUrl: imageUrl,
      defaultImageIcon: 'group'
    },
    smallestCoverImage: true,
    key: teamId,
    className: "team-allocations__team"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-allocations__team__details-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-allocations__team__details-container__details"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "team-allocations__team__details-container__details__name-container"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading4: true,
    ellipsisOverflow: true
  }, name), !balance ? /*#__PURE__*/_react.default.createElement(_uiKit.ErrorIcon, {
    className: "team-allocations__team__details-container__details__name-container__error",
    errorMessage: "This team doesn't have any credits",
    id: "".concat(teamId, "-no-credits-overview")
  }) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-allocations__team__details-container__details__credit-balance"
  }, /*#__PURE__*/_react.default.createElement(_FormattedVideoCredits.default, {
    credits: balance
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-allocations__team__details-container__details__credit-rule"
  }, /*#__PURE__*/_react.default.createElement(_FormattedVideoCredits.default, {
    credits: creditQuantity,
    isCreditRule: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "team-allocations__team__details-container__details__rollover-balance"
  }, /*#__PURE__*/_react.default.createElement(_FormattedVideoCredits.default, {
    credits: rolloverBalance,
    isRolloverBalance: true
  })))));
}

var _default = (0, _react.memo)(Allocation);

exports.default = _default;